
<template>
	<transition
		name="fade"
	>
		<div
		>
			<div
				class="position-fixed-full flex-column justify-center"
				style="z-index: 9999999; "
				:style="bottom"

				v-show="notify"
				@click="clear"
			>
				<div
					class="position-absolute-full bg-black"
					style="opacity: 0.3"
				></div>
				<div
					class="flex-column justify-center items-center position-relative pa-10 size-px-14"
					style="min-height: 80px; z-index: 9999998; "
					:class="type"
				>
					<div
						class="pa-10 radius-10 color-white text-right"
						style="max-width: 720px"
						@click="clear"
					>
						<v-alert
							:type="type ? type : 'error'"
							dense
						>

							{{ msg }}

							<button
								class="ml-10"
							><v-icon>mdi mdi-close</v-icon></button>
						</v-alert>

					</div>
				</div>
			</div>
		</div>
	</transition>

</template>

<script>

export default{
	name: 'AlertMsg'
	,props: []
	,data: () => ({
		notify: false
		,msg: '!!'
		,type: 'error'
		,config: {

		}
	})
	,watch: {
		msg: {
			handler: function(call){
				if(call){
					this.notifyMsg()
					this.notify = true
				}
			}
		}
	}
	, computed: {
		bottom: function(){
			let t = 'bottom: 0'

			if(this.config){
				t = 'bottom: ' + this.config.bottom
			}
			return t
		}
	}
	,methods: {
		clear: function(){
			this.notify = false
			this.msg = ''
			this.$emit('clearMsg')
		}
		, notifyMsg: function(){

			let timer = this.notifyMsg.timer
			if (timer) {
				clearTimeout(timer)
			}

			this.notifyMsg.timer = setTimeout(() => {
				this.clear()
			}, 10000)

			this.elapse = 1
			let t = this.notifyMsg.t
			if (t) {
				clearInterval(t)
			}

			this.notifyMsg.t = setInterval(() => {
				if (this.elapse === 3) {
					this.elapse = 0
					clearInterval(this.notifyMsg.t)
				}
				else {
					this.elapse++
				}
			})
		}
	}

	,created() {
		let self = this
		this.$bus.$on('notify', function({ type, message, config }){
			if(type == 'error1'){
				alert(message)
			}else{
				self.msg = message
				self.type = type
				self.config = config
			}
		})
	}
}
</script>


<style>

.slide-fade-enter-active {
	transition: all .3s ease;
}
.slide-fade-leave-active {
	transition: all .0s ease;
}
.slide-fade-enter{
	transform: translateY(100%);

	overflow: hidden;
	height: 100%;
}
.slide-fade-leave, .slide-fade-leave-to {
	transform: translateY(100%) ;
	opacity: 0;
	overflow: hidden;
}

.success { color: #eee !important;}

</style>